// NATIVE 

// INSTALLED 
import axios from 'axios';

// CUSTOM 
import { closeSessionGlobal, getUrlBase } from './helpers';
import { storageGetCurrentUser } from './Storage';

const intance = axios.create({
    baseURL: getUrlBase()
});



intance.interceptors.request.use(
    async(config) => {

        
        const  user =  await storageGetCurrentUser();


        const { token } = user;

        
        if ( token !== '' || token !== null ) {
            config.headers['Authorization'] = 'Bearer '+token; 
        }

        return config;
    }
);



intance.interceptors.response.use(
    (response) => {
        
        return response;
    },
    (error) => {

        
        
        if ( error.response.status === 400) {
            
            const errorformatted = {
                "ok": false,
                "hasErrors": true,
                "data": {},
                "message": error.response.data.message,
                "errors": error.response.data.message,
                "code": error.response.data.statusCode,
                "statusCode": error.response.data.statusCode
            }
            
            return Promise.reject(errorformatted);

        }
     
        const errorformatted = {
                "ok": error.response.data.ok,
                "hasErrors": error.response.data.hasErrors,
                "data": error.response.data.data,
                "message": error.response.data.message,
                "errors": error.response.data.errors,
                "code": error.response.data.statusCode,
                "statusCode": error.response.data.statusCode
        }


        

        console.log('src\commons/utils\axios.tsx')
        console.log('errorformatted ',errorformatted)

        return Promise.reject(errorformatted);
 
    }
);

export default intance;
